import { Cart } from '@/sections/shared/explore/model/Cart';
import { IClient } from '@/shared/model/client.model';
import { ICompany } from '@/shared/model/company.model';
import { IStemdoer } from '@/shared/model/stemdoer.model';
import { Module } from 'vuex';

export interface CartStateStorable {
  cart: Cart;
  client: IClient;
  company?: ICompany;
}

export const defaultCartState: CartStateStorable = {
  cart: new Cart(),
  client: null,
  company: null
};

export const cartStore: Module<CartStateStorable, any> = {
  namespaced: true,
  state: {
    cart: localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : defaultCartState.cart,
    client: localStorage.getItem('clientSelected') ? JSON.parse(localStorage.getItem('clientSelected')) : defaultCartState.client,
    company: localStorage.getItem('companySelected') ? JSON.parse(localStorage.getItem('companySelected')) : defaultCartState.company
  },
  getters: {
    cart: state => getCartFromState(state),
    cartItems: state => {
      const cart: Cart = getCartFromState(state);
      return cart.getItems();
    },
    cartTotalItems: state => {
      const cart: Cart = getCartFromState(state);
      return cart.getTotalItems();
    },
    clientSelected: state => getClientFromState(state),
    companySelected: state => getCompanyFromState(state)
  },
  mutations: {
    clearCart(state) {
      persistCartState(state, new Cart());
      persistClientState(state, null);
      persistCompanyState(state, null);
      persistCheckoutState(state, null);
    },
    addStemdoer(state, stemdoer: IStemdoer) {
      const cart: Cart = getCartFromState(state);
      cart.addToCart(stemdoer);
      persistCartState(state, cart);
    },
    removeStemdoer(state, stemdoerId: string) {
      const cart: Cart = getCartFromState(state);
      cart.removeFromCart(stemdoerId);
      persistCartState(state, cart);
    },
    setClient(state, client: IClient) {
      persistClientState(state, client);
      // Solo actualiza company si es diferente al actual
      if (client && client.company && JSON.stringify(client.company) !== JSON.stringify(state.company)) {
        persistCompanyState(state, client.company);
      }
    },
    setCompany(state, company: ICompany) {
      persistCompanyState(state, company);
    }
  }
};

const getCartFromState = (state): Cart => {
  return Object.assign(new Cart(), state.cart);
};
const getClientFromState = (state): IClient => {
  const client = Object.assign({}, state.client);
  return Object.keys(client).length === 0 ? null : client;
};

const getCompanyFromState = (state): ICompany => {
  const company = Object.assign({}, state.company);
  return Object.keys(company).length === 0 ? null : company;
};

const persistCartState = (state, cart: Cart) => {
  state.cart = cart;
  localStorage.setItem('cart', JSON.stringify(cart));
};

const persistClientState = (state, client: IClient) => {
  state.client = client;
  localStorage.setItem('clientSelected', JSON.stringify(client));
};

const persistCompanyState = (state, company: ICompany) => {
  state.company = company;
  localStorage.setItem('companySelected', JSON.stringify(company));
};

const persistCheckoutState = (state, checkout) => {
  state.checkout = checkout;
  localStorage.setItem('checkout', JSON.stringify(checkout));
};
